<template>
	<div class="main">
		<el-tabs class="large" tab-position="right" style="height: fit-content;">
			<el-tab-pane v-for="(item,index) in tabList" :label="item.tit" :key="index" class="tabs">
				<div class="tabImages" v-for="(tabImg,index) in item.imgList" :key="index">
					<el-image fit="fill" class="tabImg" :src="tabImg" :preview-src-list="item.imgList"></el-image>
				</div>
			</el-tab-pane>
		</el-tabs>
		<el-tabs class="small" tab-position="top" style="height: fit-content;">
			<el-tab-pane v-for="(item,index) in tabList" :label="item.tit" :key="index" class="tabs">
				<div class="tabImages" v-for="(tabImg,index) in item.imgList" :key="index">
					<el-image fit="fill" class="tabImg" :src="tabImg" :preview-src-list="item.imgList"></el-image>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
export default {
	name: "Staff",
	data() {
		return {
			baseImgUrl: process.env.VUE_APP_IMGURL,
			tabList: []
		}
	},
	mounted() {
		this.$api.get('about/getStaff').then(res => {
			let l = [];
			for(let i=0; i<res.length; i++){
				let s = { tit:'', imgList:[] }
				s.tit = res[i].titEn;
				let ll = [];
				for(let ii=0; ii<res[i].imgList.length; ii++){
					ll[ii] = this.baseImgUrl + res[i].imgList[ii];
				}
				s.imgList = ll;
				l.push(s);
			}
			this.tabList = l;
		});
	}
}
</script>

<style scoped>
.main{ font-family: 'SiYuan-ExtraLight', sans-serif; }
@media (max-width: 500px){
	.main{ width: 100%; padding: 20px 0 20px 0; }
	.tabs{ display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.tabImages{ width: 100%; margin: 0 1% 10px 0; animation: zoomIn; animation-duration: 1.5s; }
	.tabImg{ width: 100%; height: 200px; }
	.large{ display: none; }
	.small{ display: block; }
}
@media (min-width: 500px) and (max-width: 726px){
	.main{ width: 100%; padding: 30px 0 20px 0; }
	.tabs{ display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.tabImages{ width: 100%; margin: 0 1% 10px 0; animation: zoomIn; animation-duration: 1.5s; }
	.tabImg{ width: 100%; height: 180px; }
	.large{ display: block; }
	.small{ display: none; }
}
@media (min-width: 726px) and (max-width: 999px){
	.main{ width: 100%; padding: 30px 0 20px 0; }
	.tabs{ display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.tabImages{ width: 48%; margin: 0 1% 10px 0; animation: zoomIn; animation-duration: 1.5s; }
	.tabImg{ width: 100%; height: 180px; }
	.large{ display: block; }
	.small{ display: none; }
}
@media (min-width: 999px) and (max-width: 1251px){
	.main{ width: 100%; padding: 30px 0 20px 0; }
	.tabs{ display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.tabImages{ width: 48%; margin: 0 1% 10px 0; animation: zoomIn; animation-duration: 1.5s; }
	.tabImg{ width: 100%; height: 220px; }
	.large{ display: block; }
	.small{ display: none; }
}
@media (min-width: 1252px) and (max-width: 1845px){
	.main{ width: 100%; padding: 30px 0 20px 0; }
	.tabs{ display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.tabImages{ width: 32%; margin: 0 1% 10px 0; animation: zoomIn; animation-duration: 1.5s; }
	.tabImg{ width: 100%; height: 220px; }
	.large{ display: block; }
	.small{ display: none; }
}
@media (min-width: 1846px) and (max-width: 2200px){
	.main{ width: 100%; padding: 30px 0 20px 0; }
	.tabs{ display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.tabImages{ width: 24%; margin: 0 1% 10px 0; animation: zoomIn; animation-duration: 1.5s; }
	.tabImg{ width: 100%; height: 220px; }
	.large{ display: block; }
	.small{ display: none; }
}
@media (min-width: 2201px){
	.main{ width: 100%; padding: 30px 0 20px 0; }
	.tabs{ display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.tabImages{ width: 19%; margin: 0 1% 10px 0; animation: zoomIn; animation-duration: 1.5s; }
	.tabImg{ width: 100%; height: 220px; }
	.large{ display: block; }
	.small{ display: none; }
}
</style>